import { useState } from 'react';
import './OrderConfirmationPopUp.css';

function OrderConfirmationPopUp({ onClose, orderId }) {
  const [showForm] = useState(true);

  return (
    <div>
      {showForm && (
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <header className="modal-header">
              <h2>Thanks for your order!</h2>
              <button
                className="modal-close"
                onClick={onClose}
                aria-label="Close"
              >
                &times;
              </button>
            </header>
            <div className="modal-body">
              <p className="body-copy">Thanks for placing your order</p>

              <p className="order-id">
                <span className="order-id-number">{orderId}</span>
              </p>

              <p className="subtext">We will send you an email to get started!</p>

              <p className="subtext2">
                If you have any questions, feel free to <a href="mailto:info@snappo.io">contact us</a>.
              </p>
            </div>
          </div>
        </div>
      )}
    </div> 
  );
}
export default OrderConfirmationPopUp;
